const SkilledCompetitionStepper = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <div className="flex absolute bottom-3 xs:gap-3 lg:gap-8 items-center w-full justify-center">
      <div className="select-dc-prize flex gap-2 items-center relative">
        {isMobile ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M15.3998 5.7168V7.94537M15.3998 12.4025V14.6311M15.3998 19.0882V21.3168M4.06647 5.7168L19.9331 5.7168C20.5343 5.7168 21.1108 5.95159 21.5359 6.36953C21.961 6.78747 22.1998 7.35431 22.1998 7.94537V11.2882C21.5986 11.2882 21.0221 11.523 20.597 11.941C20.1719 12.3589 19.9331 12.9257 19.9331 13.5168C19.9331 14.1079 20.1719 14.6747 20.597 15.0926C21.0221 15.5106 21.5986 15.7454 22.1998 15.7454V19.0882C22.1998 19.6793 21.961 20.2461 21.5359 20.6641C21.1108 21.082 20.5343 21.3168 19.9331 21.3168H4.06647C3.46531 21.3168 2.88878 21.082 2.4637 20.6641C2.03861 20.2461 1.7998 19.6793 1.7998 19.0882V15.7454C2.40096 15.7454 2.9775 15.5106 3.40258 15.0926C3.82766 14.6747 4.06647 14.1079 4.06647 13.5168C4.06647 12.9257 3.82766 12.3589 3.40258 11.941C2.9775 11.523 2.40096 11.2882 1.7998 11.2882V7.94537C1.7998 7.35431 2.03861 6.78747 2.4637 6.36953C2.88878 5.95159 3.46531 5.7168 4.06647 5.7168Z"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path
              d="M27.0395 8.78223V12.5584M27.0395 20.1108V23.887M27.0395 31.4393V35.2155M7.83585 8.78223L34.721 8.78223C35.7396 8.78223 36.7165 9.18007 37.4368 9.88825C38.1571 10.5964 38.5617 11.5569 38.5617 12.5584V18.2227C37.5431 18.2227 36.5662 18.6205 35.8459 19.3287C35.1257 20.0369 34.721 20.9974 34.721 21.9989C34.721 23.0004 35.1257 23.9609 35.8459 24.669C36.5662 25.3772 37.5431 25.7751 38.5617 25.7751V31.4393C38.5617 32.4409 38.1571 33.4013 37.4368 34.1095C36.7165 34.8177 35.7396 35.2155 34.721 35.2155H7.83585C6.81723 35.2155 5.84032 34.8177 5.12004 34.1095C4.39976 33.4013 3.99512 32.4409 3.99512 31.4393L3.99512 25.7751C5.01374 25.7751 5.99065 25.3772 6.71093 24.669C7.43121 23.9609 7.83585 23.0004 7.83585 21.9989C7.83585 20.9974 7.43121 20.0369 6.71093 19.3287C5.99065 18.6205 5.01374 18.2227 3.99512 18.2227L3.99512 12.5584C3.99512 11.5569 4.39976 10.5964 5.12004 9.88825C5.84032 9.18007 6.81723 8.78223 7.83585 8.78223Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        <span className="text-white font-jost font-medium xs:text-[12px] lg:text-[20.333px] xs:leading-[12px] lg:leading-[20.333px] text-left">
          Select <br /> prize
        </span>
        <span className="xs:text-[12px] lg:text-[16px] absolute bg-[#E87600] -top-[6px] -left-[9px] rounded-full xs:w-[18px] xs:h-[18px] lg:w-[24px] lg:h-[24px] text-white font-jost font-semibold flex justify-center items-center">
          1
        </span>
      </div>
      {isMobile ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path
            d="M1 4.91675H11M11 4.91675L7 8.91675M11 4.91675L7 0.916748"
            stroke="white"
            strokeOpacity="0.38"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
          <path
            d="M1.5 8.98285H18.4444M18.4444 8.98285L11.6667 15.7606M18.4444 8.98285L11.6667 2.20508"
            stroke="white"
            strokeOpacity="0.38"
            strokeWidth="2.54166"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <div className="play-the-game flex gap-2 items-center relative">
        {isMobile ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M3.73145 12.8116C3.73145 15.0641 4.61444 17.2244 6.18617 18.8171C7.7579 20.4099 9.88963 21.3047 12.1124 21.3047C14.3352 21.3047 16.4669 20.4099 18.0386 18.8171C19.6104 17.2244 20.4933 15.0641 20.4933 12.8116C20.4933 10.5591 19.6104 8.39882 18.0386 6.80606C16.4669 5.21329 14.3352 4.31848 12.1124 4.31848C9.88963 4.31848 7.7579 5.21329 6.18617 6.80606C4.61444 8.39882 3.73145 10.5591 3.73145 12.8116Z"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.7912 12.8091H22M2 12.8091H5.20879"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9.91016 12.8097H14.3058M12.108 10.5825V15.0369"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.1973 22.9207L12.1973 19.6689"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.1973 6.16846L12.1973 2.91673"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path
              d="M7.04492 20.8044C7.04492 24.6212 8.5411 28.2816 11.2043 30.9804C13.8675 33.6793 17.4796 35.1955 21.246 35.1955C25.0123 35.1955 28.6244 33.6793 31.2876 30.9804C33.9508 28.2816 35.447 24.6212 35.447 20.8044C35.447 16.9877 33.9508 13.3272 31.2876 10.6284C28.6244 7.92953 25.0123 6.41333 21.246 6.41333C17.4796 6.41333 13.8675 7.92953 11.2043 10.6284C8.5411 13.3272 7.04492 16.9877 7.04492 20.8044Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.5631 20.8005H38.0002M4.11133 20.8005H9.54844"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17.5146 20.8015H24.9627M21.2387 17.0276V24.5754"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3896 37.9346L21.3896 32.4247"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3896 9.54834L21.3896 4.03847"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        <span className="text-white font-jost font-medium xs:text-[12px] lg:text-[20.333px] xs:leading-[12px] lg:leading-[20.333px] text-left">
          Play the <br /> game
        </span>
        <span className="xs:text-[12px] lg:text-[16px] absolute bg-[#E87600] -top-[6px] -left-[9px] rounded-full xs:w-[18px] xs:h-[18px] lg:w-[24px] lg:h-[24px] text-white font-jost font-semibold flex justify-center items-center">
          2
        </span>
      </div>
      {isMobile ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path
            d="M1 4.91675H11M11 4.91675L7 8.91675M11 4.91675L7 0.916748"
            stroke="white"
            strokeOpacity="0.38"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
          <path
            d="M1.5 8.98285H18.4444M18.4444 8.98285L11.6667 15.7606M18.4444 8.98285L11.6667 2.20508"
            stroke="white"
            strokeOpacity="0.38"
            strokeWidth="2.54166"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <div className="win-your-dc-car flex gap-2 items-center relative">
        {isMobile ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
              d="M22 18.6416V22.1416C22 22.6939 21.5523 23.1416 21 23.1416H18C17.4477 23.1416 17 22.6939 17 22.1416V20.6416"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.99999 20.6416V22.1416C6.99999 22.6939 6.55228 23.1416 5.99999 23.1416H3C2.44771 23.1416 2 22.6939 2 22.1416V18.6416"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.00098 20.6416L8.70073 18.5169C8.8905 18.2797 9.17781 18.1416 9.48159 18.1416H14.5203C14.8241 18.1416 15.1114 18.2797 15.3012 18.5169L17.001 20.6416"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M22 16.1417L18 17.1417"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 16.1417L5.99999 17.1417"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.8896 11.1417H21.0008"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3 11.1417H5.11111"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2 15.1417V18.6417C2 19.7463 2.89543 20.6417 4 20.6417H20C21.1045 20.6417 22 19.7463 22 18.6417V15.1417C22 14.0372 21.1045 13.1417 20 13.1417V13.1417L17 14.1417H6.99999L4 13.1417V13.1417C2.89543 13.1417 2 14.0372 2 15.1417Z"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.001 13.1417L18.0725 9.67043C17.7197 9.0355 17.0505 8.64172 16.3241 8.64172H7.67778C6.95145 8.64172 6.2822 9.0355 5.92946 9.67043L4.00098 13.1417"
              stroke="white"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.5 7.6167C4.5 6.23599 5.61929 5.1167 7 5.1167C5.61929 5.1167 4.5 3.99741 4.5 2.6167C4.5 3.99741 3.38071 5.1167 2 5.1167C3.38071 5.1167 4.5 6.23599 4.5 7.6167Z"
              stroke="white"
              strokeWidth="0.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.5 7.91675C21.5 7.08832 22.1716 6.41675 23 6.41675C22.1716 6.41675 21.5 5.74518 21.5 4.91675C21.5 5.74518 20.8284 6.41675 20 6.41675C20.8284 6.41675 21.5 7.08832 21.5 7.91675Z"
              stroke="white"
              strokeWidth="0.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.5 5.91675C13.5 5.08832 14.1716 4.41675 15 4.41675C14.1716 4.41675 13.5 3.74518 13.5 2.91675C13.5 3.74518 12.8284 4.41675 12 4.41675C12.8284 4.41675 13.5 5.08832 13.5 5.91675Z"
              stroke="white"
              strokeWidth="0.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" viewBox="0 0 41 42" fill="none">
            <path
              d="M37.5562 30.6831V36.6136C37.5562 37.5495 36.7976 38.3081 35.8617 38.3081H30.7784C29.8426 38.3081 29.084 37.5495 29.084 36.6136V34.072"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.1392 34.072V36.6136C12.1392 37.5495 11.3806 38.3081 10.4448 38.3081H5.36143C4.42562 38.3081 3.66699 37.5495 3.66699 36.6136V30.6831"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.1406 34.072L15.0208 30.4719C15.3423 30.0699 15.8291 29.8359 16.3439 29.8359H24.8818C25.3965 29.8359 25.8833 30.0699 26.2049 30.4719L29.085 34.072"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M37.5551 26.4473L30.7773 28.1417"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.66699 26.4473L10.4448 28.1417"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M32.2852 17.9749H35.8623"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.36133 17.9749H8.93848"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.66699 24.7529V30.6834C3.66699 32.5551 5.18425 34.0723 7.05587 34.0723H34.1669C36.0385 34.0723 37.5558 32.5551 37.5558 30.6834V24.7529C37.5558 22.8813 36.0385 21.364 34.1669 21.364V21.364L29.0836 23.0585H12.1392L7.05587 21.364V21.364C5.18425 21.364 3.66699 22.8813 3.66699 24.7529Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M34.1687 21.3637L30.9009 15.4819C30.3032 14.406 29.1693 13.7388 27.9385 13.7388H13.2878C12.057 13.7388 10.923 14.406 10.3253 15.4819L7.05762 21.3637"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.9031 12.0027C7.9031 9.66319 9.79967 7.76662 12.1392 7.76662C9.79967 7.76662 7.9031 5.87005 7.9031 3.53052C7.9031 5.87005 6.00653 7.76662 3.66699 7.76662C6.00653 7.76662 7.9031 9.66319 7.9031 12.0027Z"
              stroke="white"
              strokeWidth="1.01667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.7077 12.5106C36.7077 11.1069 37.8456 9.96891 39.2493 9.96891C37.8456 9.96891 36.7077 8.83097 36.7077 7.42725C36.7077 8.83097 35.5697 9.96891 34.166 9.96891C35.5697 9.96891 36.7077 11.1069 36.7077 12.5106Z"
              stroke="white"
              strokeWidth="1.01667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.152 9.12141C23.152 7.71769 24.29 6.57975 25.6937 6.57975C24.29 6.57975 23.152 5.44181 23.152 4.03809C23.152 5.44181 22.0141 6.57975 20.6104 6.57975C22.0141 6.57975 23.152 7.71769 23.152 9.12141Z"
              stroke="white"
              strokeWidth="1.01667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        <span className="text-white font-jost font-medium xs:text-[12px] lg:text-[20.333px] xs:leading-[12px] lg:leading-[20.333px] text-left">
          Win your
          <br /> dream car
        </span>
        <span className="xs:text-[12px] lg:text-[16px] absolute bg-[#E87600] -top-[6px] -left-[9px] rounded-full xs:w-[18px] xs:h-[18px] lg:w-[24px] lg:h-[24px] text-white font-jost font-semibold flex justify-center items-center">
          3
        </span>
      </div>
    </div>
  );
};
export default SkilledCompetitionStepper;
